import { PackageActivationTableContainer } from './PackageActivationTable';

export const PackageActivationPage = () => {
    return (
        <div>
            <PackageActivationTableContainer/>
        </div>
    );
};
